import { render, staticRenderFns } from "./AddBusinessDatabus.vue?vue&type=template&id=9456ce52&scoped=true"
import script from "./AddBusinessDatabus.vue?vue&type=script&lang=js"
export * from "./AddBusinessDatabus.vue?vue&type=script&lang=js"
import style0 from "./AddBusinessDatabus.vue?vue&type=style&index=0&id=9456ce52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9456ce52",
  null
  
)

export default component.exports